import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import { LoadingSpinnerButton } from "./PathwayButtons";
import { ErrorMessage } from "./Alerts/PathwayAlertMessages";

export const Modal3Options = (props) => {
    const [deleteClicked, setDeleteClicked] = useState(false);

    const handlePrimarySubmit = (e) => {
        props.handlePrimarySubmit(e);
        if (props.submitAndToggle) {
            props.toggleModal();
        }
    };

    const handleSecondarySubmit = () => {
        props.handleSecondarySubmit();
        if (props.submitAndToggle) {
            props.toggleModal();
        }
        if (props.secondaryIsDelete) {
            setDeleteClicked(false);
        }
    };

    return (
        <Modal isOpen={props.isOpen} size={props.size}>
            <ModalHeader toggle={props.toggleModal}>{props.title}</ModalHeader>
            <ModalBody>
                <ErrorMessage>{props.errorMessage}</ErrorMessage>
                {props.children}
            </ModalBody>
            <ModalFooterRow>
                {!props.hidePrimaryOption && (
                    <LoadingSpinnerButton
                        loading={props.isLoading}
                        onClick={handlePrimarySubmit}
                        color={props.primaryButtonColor ? props.primaryButtonColor : "primary"}
                        disabled={props.disabled}
                        buttonCyData={props.buttonCyData}
                    >
                        {props.primaryButtonText}
                    </LoadingSpinnerButton>
                )}

                {!props.hideSecondaryOption && (
                    <>
                        {!props.secondaryIsDelete ? (
                            <LoadingSpinnerButton
                                loading={props.isLoading}
                                disabled={props.disabled}
                                onClick={handleSecondarySubmit}
                            >
                                {props.secondaryButtonText}
                            </LoadingSpinnerButton>
                        ) : deleteClicked ? (
                            <LoadingSpinnerButton
                                color="danger"
                                loading={props.isLoading}
                                disabled={props.disabled}
                                onClick={handleSecondarySubmit}
                            >
                                Wirklich löschen?
                            </LoadingSpinnerButton>
                        ) : (
                            <LoadingSpinnerButton
                                color="danger"
                                loading={props.isLoading}
                                disabled={props.disabled}
                                onClick={() => setDeleteClicked(true)}
                            >
                                Löschen
                            </LoadingSpinnerButton>
                        )}
                    </>
                )}

                <Button color="secondary" onClick={props.toggleModal}>
                    Abbrechen
                </Button>
            </ModalFooterRow>
        </Modal>
    );
};

Modal3Options.propTypes = {
    children: PropTypes.element.isRequired,
    disabled: PropTypes.bool.isRequired,
    handlePrimarySubmit: PropTypes.func.isRequired,
    handleSecondarySubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
    primaryButtonText: PropTypes.string.isRequired,
    primaryButtonColor: PropTypes.string,
    secondaryIsDelete: PropTypes.bool,
    secondaryButtonText: PropTypes.string,
    hideSecondaryOption: PropTypes.bool,
    hidePrimaryOption: PropTypes.bool,
    size: PropTypes.any,
    title: PropTypes.string.isRequired,
    toggleModal: PropTypes.func.isRequired,
    buttonCyData: PropTypes.string,
};

const ModalFooterRow = styled(ModalFooter)`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 0.4fr));
    justify-content: space-between;
    column-gap: var(--gap-m);
`;
